const config = {
    API_BASE_URL: process.env.REACT_APP_API_URL || "https://us-central1-welcome-compass-dev.cloudfunctions.net",
    ENVIRONMENT: process.env.REACT_APP_ENV || 'development',
    GA_TRACKING_ID: 'G-JW8RNRF427',
    MIXPANEL_PROJECT_TOKEN: '7db8f45a9cba66bf49b813266e2ce9a3'
  };
  
  export default config;